import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17 16.293l-3.274-3.274C14.521 12.065 15 10.839 15 9.5 15 6.462 12.538 4 9.5 4S4 6.462 4 9.5 6.462 15 9.5 15c1.339 0 2.565-.479 3.519-1.274L16.293 17l.707-.707zM9.5 14C7.019 14 5 11.981 5 9.5S7.019 5 9.5 5 14 7.019 14 9.5 11.981 14 9.5 14z',
  ],
  height: 20,
  width: 20,
});
